import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
var ConditionMedium = forwardRef(function ConditionMedium2(props, ref) {
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), {}, {
    children: [/* @__PURE__ */jsx("path", {
      d: "M16 16H17V17H16V16Z"
    }), /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 5C5.44772 5 5 5.44772 5 6V9C5 9.55228 5.44772 10 6 10H9C9.55228 10 10 9.55228 10 9V8H11.5V16C11.5 16.5523 11.9477 17 12.5 17H14V18C14 18.5523 14.4477 19 15 19H18C18.5523 19 19 18.5523 19 18V15C19 14.4477 18.5523 14 18 14H15C14.4477 14 14 14.4477 14 15V16H12.5V8C12.5 7.44772 12.0523 7 11.5 7H10V6C10 5.44772 9.55228 5 9 5H6ZM9 6H6V9H9V6ZM18 15H15V18H18V15Z"
    }), /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 5C14.4477 5 14 5.44772 14 6V7H13.5V8H14V9C14 9.55228 14.4477 10 15 10H18C18.5523 10 19 9.55228 19 9V6C19 5.44772 18.5523 5 18 5H15ZM18 6H15V9H18V6Z"
    })]
  }));
});
export { ConditionMedium };